module.exports = __webpack_public_path__ + "static/img/Frame 1926.4e11fa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/swiper3/Frame 1926.png
// module id = eKB9
// module chunks = 12